/* ================================================
   CANDy BLOOD - Hero Section Animations
   ================================================ */

function initHeroSection() {

  const openingOverlay = document.querySelector(".opening-overlay");
  const openingLogo = document.querySelector(".opening-logo");

  // Only block scroll if overlay exists
  if (openingOverlay && openingLogo) {
    document.body.style.overflow = "hidden";

    // Opening overlay animation
    const tlOpening = gsap.timeline();

    tlOpening
      .to(".opening-logo", {
        opacity: 1,
        scale: 1,
        duration: 1.5,
        ease: "power2.out"
      })
      .to(".opening-overlay", {
        opacity: 0,
        duration: 1,
        ease: "power2.inOut",
        onComplete: () => {
          openingOverlay.style.display = "none";
          // Restore scrolling
          document.body.style.overflow = "";
        }
      }, "+=0.5");

    // Safety fallback - restore scroll after max 5 seconds no matter what
    setTimeout(() => {
      document.body.style.overflow = "";
    }, 5000);
  } else {
    // No overlay, ensure scroll is enabled
    document.body.style.overflow = "";
  }

  // Hero content animations (after overlay)
  const tlHero = gsap.timeline({ delay: 2.5 });

  tlHero
    .to(".hero-title", {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: "power3.out"
    })
    .to(".hero-title-jp", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power3.out"
    }, "-=0.8")
    .to(".hero-tagline", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power3.out"
    }, "-=0.6")
    .to(".hero-corner", {
      opacity: 1,
      duration: 0.8,
      stagger: 0.1,
      ease: "power2.out"
    }, "-=0.5")
    .to(".scroll-indicator", {
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    }, "-=0.3");

  // Parallax effect on hero video
  gsap.to(".hero-video", {
    yPercent: 30,
    ease: "none",
    scrollTrigger: {
      trigger: ".hero-section",
      start: "top top",
      end: "bottom top",
      scrub: true
    }
  });

  // Hero content fade out on scroll
  gsap.to(".hero-content", {
    opacity: 0,
    y: -50,
    ease: "none",
    scrollTrigger: {
      trigger: ".hero-section",
      start: "center top",
      end: "bottom top",
      scrub: true
    }
  });

  // Scroll indicator hide on scroll
  gsap.to(".scroll-indicator", {
    opacity: 0,
    scrollTrigger: {
      trigger: ".hero-section",
      start: "top top",
      end: "20% top",
      scrub: true
    }
  });

  // Nav background on scroll
  ScrollTrigger.create({
    trigger: ".hero-section",
    start: "bottom 80%",
    onEnter: () => document.querySelector(".main-nav")?.classList.add("scrolled"),
    onLeaveBack: () => document.querySelector(".main-nav")?.classList.remove("scrolled")
  });
}

// Export for main.js
window.initHeroSection = initHeroSection;
